<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-sheet class="card-rounded">
                <v-row no-gutters>
                    <v-col cols="12" class="card-background">
                        <v-row no-gutters class="px-4 py-4">
                            <v-avatar
                                color="#FFF"
                                size="148"
                                class="avatar-frame"
                            >
                                <v-img
                                    v-if="applicant?.student_img_base64 == null"
                                    :src="require('@/assets/student.png')"
                                ></v-img>
                                <v-img
                                    v-else
                                    :src="applicant?.student_img_base64?.data"
                                ></v-img>
                            </v-avatar>
                        </v-row>
                        <v-row no-gutters justify="end" class="px-4">
                            <v-btn
                                color="white"
                                outlined
                                small
                                @click="onAction()"
                                class="square-btn"
                            >
                                <v-icon small>
                                    {{
                                        currentStep == 5
                                            ? "mdi-eye"
                                            : "mdi-pencil"
                                    }}
                                </v-icon>
                            </v-btn>
                        </v-row>
                    </v-col>
                    <!-- ระดับชั้นที่ต้องการสมัคร -->
                    <v-col cols="12" class="pa-4">
                        <v-row no-gutters class="mb-3">
                            <span class="header-text"
                                >{{ $t('message.adminPage.studentInfo.applicationDetail')}}</span
                            >
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="4">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.grade')}}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.grade?.[`student_year_name_${locale}`]
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="8">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.curriculum')}}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.track?.[`program_name_${locale}`]
                                    }}</span></v-row
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- ข้อมูลนักเรียน -->
                    <v-col cols="12" class="pa-4">
                        <v-row no-gutters class="mb-3">
                            <span class="header-text">{{ $t('message.adminPage.studentInfo.applicantsInfo')}}</span>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.idCardNo')}}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.citizenId
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="8" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.fullname')}}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        fullName
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.ethnicity') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.ethnicity?.[`name_${locale}`]
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.nationality') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.nationality?.[`name_${locale}`]
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.religion') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.religion?.[`name_${locale}`]
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.birthdate') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        birthdayDate(applicant?.birthDate)
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.mobileNo') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.phoneNumber
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.email') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.email
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.gender') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        $t(`${gender(applicant?.sex)}`)
                                    }}</span></v-row
                                >
                            </v-col>
                            <v-col cols="4" class="mb-3">
                                <v-row no-gutters
                                    ><span class="caption-text"
                                        >{{ $t('message.adminPage.studentInfo.talent') }}</span
                                    ></v-row
                                >
                                <v-row no-gutters
                                    ><span class="default-text">{{
                                        applicant?.talent?.length == 0 ? "-" : applicant?.talent
                                    }}</span></v-row
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import i18n from '@/i18n';
import { formatDateTime } from '@/utils/date';
export default {
    props: {
        applicantInfo: Object,
        currentStep: String,
    },
    mounted() {
        this.retrievedData();
    },
    data() {
        return {
            applicant: {},
        };
    },
    computed: {
        locale() {
            return i18n.locale;
        },
        fullName() {
            return `${this.applicant?.fullName?.prefix?.[`text_${this.locale}`]} ${this.applicant?.fullName?.[`name_${this.locale}`]} ${this.applicant.fullName?.[`surname_${this.locale}`]}`
        },
        
    },
    methods: {
        retrievedData() {
            let applicant = JSON.parse(JSON.stringify(this.applicantInfo));
            this.applicant = applicant;
        },
        onAction() {
            let action = this.currentStep == 5 ? "view" : "edit";
            this.$emit(`onAction`, action, `basic`);
        },
        gender(sex){
            const gender = {
                MALE: "message.form.studentData.male",
                FEMALE: "message.form.studentData.female",
            };
            return gender[sex];
        },
        birthdayDate(date) {
            let newDate = Date.parse(date);
            if (newDate) return formatDateTime(newDate, this.locale);
            else return "";
        },
    },
};
</script>

<style scoped lang="scss">
.square-btn {
    min-width: 36px !important;
    width: 36px !important;
    height: 36px !important;
}
.avatar-frame {
    border: 3px solid #fff;
    position: absolute;
}
.v-btn--outlined {
    border: 2px solid rgb(255, 255, 255);
}
.card-background {
    background-color: #7fa2cc;
    border-radius: 30px 30px 0 0;
    position: relative;
    min-height: 90px;
    margin-bottom: 80px;
}
.header-text {
    font-family: "Prompt";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #255d98;
}
.caption-text {
    font-family: "Prompt";
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #9d9b9a;
}
.default-text {
    font-family: "Sarabun";
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #37323c;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
.card-rounded {
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
    border-radius: 30px 30px 10px 10px;
}
</style>
